<template>
  <div>
    <div class="text-center">
      <v-dialog v-model="cargando" hide-overlay persistent width="300">
        <v-card color="primary" dark class="loading">
          <v-card-text>
            Espere un momento
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-row justify="center">
      <v-col cols="8" class="text-center">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="nombre"
            :rules="[rules.required]"
            label="Nombre"
            required
          ></v-text-field>
          <v-text-field
            v-model="apellido"
            :rules="[rules.required]"
            label="Apellido"
            required
          ></v-text-field>
          <v-text-field
            v-model="dni"
            :rules="[rules.required, rules.min]"
            label="DNI"
            required
            @keypress="soloNumeros"
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="[rules.email]"
            label="E-mail"
            required
          ></v-text-field>

          <v-select
            v-model="perfilSeleccionado"
            :items="perfiles"
            item-text="rol"
            item-value="idRol"
            :rules="[(v) => !!v || 'Perfil es obligatorio']"
            label="Perfil del Sistema"
            required
          ></v-select>

          <!--<v-layout align-center wrap class="topPadding30">
            <v-flex xs6>
              <v-img :src="urlImage" height="125" contain></v-img>
            </v-flex>
            <v-flex xs6>
              <v-btn>Subir Archivo</v-btn>
            </v-flex>
          </v-layout>-->

          <v-row>
            <v-col>
              <v-btn :disabled="!valid" color="success" @click="validate"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data: () => ({
    urlImage: require("../../assets/imgs/perfil.png"),
    valid: true,
    cargando: false,
    nombre: "",
    apellido: "",
    dni: "",
    email: "",
    perfilSeleccionado: "",
    perfiles: [],
    rules: {
      required: (value) => !!value || "Campo Obligatorio.",
      min: (v) => (v && v.length >= 7) || "Mínimo 7 caracteres",
      email: (v) => /.+@.+/.test(v) || "Debe ingresar un E-mail valido",
      caracteristica: (v) => (v && v.length >= 4) || "Mínimo 6 numeros",
      cel: (v) => (v && v.length >= 6) || "Mínimo 6 numeros",
    },
  }),
  props: ["idUsuario", "usuario", "reset"],
  computed: {},
  mounted: function () {
    //console.log("editarCrearUsuario -> Mounted !", this.usuario);
    this.cargarDatosUsuario();
    this.obtenerRolesUsuarios();
  },
  methods: {
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        //console.log("formulario valido");
        this.cargando = true;
        this.valid = false;

        let params =
          "idusuario=" +
          this.idUsuario +
          "&nombre=" +
          this.nombre +
          "&apellido=" +
          this.apellido +
          "&dni=" +
          this.dni +
          "&mail=" +
          this.email +
          "&idcategoria=" +
          this.perfilSeleccionado;
        //console.log("formulario valido: ", params);
        let resultado = API.enviar("get", "guardarUsuario", params);

        resultado
          .then((result) => {
            if (result.data.msj == "ok") {
              this.$emit("editarCrearUsuario:mostrarOcultarDialog");
              this.$emit("editarCrearUsuario:listarUsuarios");
            }
          })
          .catch((error) => {
            console.log(
              "editarCrearUsuario | methods | guardarUsuario |  catch: -> ",
              error
            );
          })
          .finally(() => {
            this.cargando = false;
          });
      } else {
        //console.log("formulario invalido");
      }
      this.dialog = false;
    },
    obtenerRolesUsuarios() {
      let resultado = API.enviar("get", "obtenerRolesUsuario", "");
      resultado
        .then((result) => {
          /*console.log(
              "obtenerRolesUsuario | methods |  then: -> " + result.data.result
            );*/

          if (result.data.msj == "ok") this.perfiles = result.data.result;
        })
        .catch((error) => {
          console.log("obtenerRolesUsuario | methods |  catch: -> ", error);
        });
    },
    cargarDatosUsuario() {
      console.log("idUsuario: ", this.idUsuario);
      if (this.idUsuario != -1) {
        this.nombre = API.ucFirst(this.usuario.nombre);
        this.apellido = API.ucFirst(this.usuario.apellido);
        this.dni = this.usuario.dni;
        this.email = this.usuario.mail;
        this.perfilSeleccionado = this.usuario.idCategoria;
      }
    },
  },
  watch: {
    reset: function () {
      //this.$refs.form.resetValidation();
      this.$refs.form.reset();

      if (this.reset) {
        console.log("reset True");

        if (this.idUsuario != -1) {
          this.cargarDatosUsuario();
          /*this.nombre = API.ucFirst(this.usuario.nombre);
          this.apellido = API.ucFirst(this.usuario.apellido);
          this.dni = this.usuario.dni;
          this.email = this.usuario.mail;
          this.perfilSeleccionado = this.usuario.idCategoria;*/
        }

        this.obtenerRolesUsuarios();
      }
    },
  },
};
</script>

<style scoped>
.topPadding30 {
  padding-top: 30px;
}

.bottomPadding30 {
  padding-bottom: 30px;
}
</style>